document.addEventListener('DOMContentLoaded',function(){
  if(location.pathname.includes('bedruckte-armbander-fertig-konfektioniert'))return;
  var text=document.querySelector('[data-text]');
  if(!text)return;
  var step=text.closest('.step');
  var label=document.createElement('label');
  label.append(document.createTextNode('Textabstand'));
  var select=document.createElement('select');
  select.name='properties[Textabstand]';
  var automatic=document.createElement('option');
  automatic.value='Optisch angepasst';
  automatic.textContent='Optisch angepasst';
  var custom=document.createElement('option');
  custom.value='Wunschabstand';
  custom.textContent='Wunschabstand';
  select.append(automatic,custom);
  label.appendChild(select);

  var help=document.createElement('small');
  help.className='text-spacing-help';
  help.textContent='Abstand zwischen den wiederkehrenden Druckmotiven.';

  var customLabel=document.createElement('label');
  customLabel.className='custom-spacing';
  customLabel.hidden=true;
  customLabel.append(document.createTextNode('Wunschabstand in cm'));
  var input=document.createElement('input');
  input.type='number';
  input.name='properties[Wunschabstand in cm]';
  input.min='.5';
  input.max='100';
  input.step='.5';
  input.placeholder='z. B. 5';
  input.disabled=true;
  customLabel.appendChild(input);

  function update(){
    var show=select.value==='Wunschabstand';
    customLabel.hidden=!show;
    input.disabled=!show;
    input.required=show;
    if(!show)input.value='';
  }
  select.addEventListener('change',update);
  step.append(label,help,customLabel);
  update();
});
